class PriceRange {
  constructor(priceRange = {}) {
    this.min = priceRange.min || 0;
    this.max = priceRange.max;
  }
}

export default PriceRange;
